module.exports = __webpack_public_path__ + "static/media/igloo.ba12b690.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/igloo.jpg
// module id = 201
// module chunks = 0